// actions/connect/instances.js

//import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

// --- ALL ---

export function connectInstancesHasErrored(bool) {
  return {
    type: 'CONNECT_INSTANCES_HAS_ERRORED',
    hasErrored: bool
  };
}

export function connectInstancesIsLoading(bool) {
  return {
    type: 'CONNECT_INSTANCES_IS_LOADING',
    isLoading: bool
  };
}

export function connectInstancesFetchDataSuccess(obj) {
  return {
    type: 'CONNECT_INSTANCES_FETCH_DATA_SUCCESS',
    obj
  };
}

export function connectInstancesFetchData(host) {
  return (dispatch) => {
    dispatch(connectInstancesIsLoading(true));
    dispatch(connectInstancesHasErrored(false));
    fetch(host + 'connect/instances', {
      method: 'get'
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(connectInstancesFetchDataSuccess(result));
            dispatch(connectInstancesHasErrored(false));
            dispatch(connectInstancesIsLoading(false));
            PubSub.publish('connect.chat.instances', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(connectInstancesHasErrored(true));
            dispatch(connectInstancesIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(connectInstancesHasErrored(true));
      dispatch(connectInstancesIsLoading(false));
    });
  };
}